<template>
  <div class="tableHeader_div">
    <div class="tableHeader">
      <div class="left">
        <slot name="left"></slot>
        <pt-search v-if="!showTitle &&   showLeft" :style="leftStyle" v-model="searchText" :placeholder="placeholder" @searchEvent="searchEvent"></pt-search>
        <span v-if="showTitle && showLeft" class="title">{{$t(title)}}</span>
      </div>
      <div class="right">
        <div class="select-div" v-if="$slots.select" :style="showAdd?'':'padding-right:0px;'">
          <slot name="select"></slot>
        </div>
        <div class="otherFileter" v-if="otherFilter"><span style="user-select: none;" @click="changeOtherFilter">{{otherText}} <a-icon v-if="!isOtherFilter" type="caret-up" style="color:#fabe00" /><a-icon  v-if="isOtherFilter" type="caret-down" /></span></div>
        <slot name="rightOpration"></slot>
        <div class="right-opration" v-if="$slots.select && showLine"></div>
        <div class="add-btn" v-if="showAdd">
          <a-button type="primary" shape="circle" icon="plus" @click.stop="clickEvent"></a-button>
        </div>
      </div>

    </div>
    <div v-show="!isOtherFilter" class="otherFilter_div">
      <slot name="otherSelect"></slot>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'tableHeader',
    props:{
      placeholder:{
        type:String,
      },
      otherFilter:{
        type:Boolean,
        default:false,
      },
      otherText:{
        type:String,
        default:'高级筛选'
      },
      showTitle:{
        type:Boolean,
        default:false,
      },
      showLeft:{
        type:Boolean,
        default:true,
      },
      showAdd:{
        type:Boolean,
        default:true,
      },
      text:{
        type:String,
        default:null,
      },
      leftStyle:{
        type:String,
        default:"width: 300px"
      },
      showLine:{
        type:Boolean,
        default:true,
      }
    },
    computed:{
      title(){
        return this.text?this.text:this.$route.meta.title
      }
    },
    data() {
      return {
        searchText:'',
        isOtherFilter:true,
      }
    },
    mounted() {

    },
    methods: {
      searchEvent(){
        this.$emit('search',this.searchText)
      },
      clickEvent(){
        console.log('add - emp')
        this.$emit('add')
      },
      changeOtherFilter(){
        this.isOtherFilter = !this.isOtherFilter
        if(this.isOtherFilter){
          this.$emit('closeOtherFilter')
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../core/diy";
  .tableHeader_div{
    flex: auto;
    .otherFilter_div{
      margin-top: 10px;
      padding-top: 10px;
    }
  }
  .tableHeader{
    display: flex;
    justify-content: space-between;
    width: 100%;
    .left{
      flex: auto;
    }
    .right{
      display: flex;
      align-items:center;
      flex: none;
    }
    .right-opration{
      min-width: 60px;
    }
    .title{
      font-size: 18px;
    }
    .select-div{
      font-size: 12px;
      padding-right: 30px;
      position: relative;
      >span{
        font-size: 14px;
        color: #999999;
        padding-left: 30px;
        padding-right: 15px;
      }
    }
    .otherFileter{
      cursor: pointer;
      padding-top: 10px;
    }
    .add-btn{
      width: 65px;
      text-align: right;
      button{
        color: @primary-6;
        box-shadow: 0 7px 9px 0 rgba(59,46,38,0.42);
      }
      button:hover{
        color: @primary-6;
      }
    }
  }
</style>